<template>
  <div>
    <div class="smart-main-search-container flex flex-wrap">

      <div class="flex-1"></div>
      <div class="flex">
        <el-button type="primary" @click="add" plain>新增小区管理员</el-button>
      </div>
    </div>

    <div class="content mt-20">
      <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
    </div>

    <div class="flex flex-right mt-20">
      <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
    </div>
    <form-dialog ref="model" title="账号信息" @on-confirm="save">
      <div slot="dialog-main">
        <el-form>
          <el-form-item label="小区" label-width="120px">
            <dropdown v-model="temp.gardenId" data-url="/smartMeterServer/user/gardenInfo" value-key="gardenid" show-key="gardenname"></dropdown>
          </el-form-item>
          <el-form-item label="账号" label-width="120px">
            <el-input v-model="temp.passport"></el-input>
          </el-form-item>
          <el-form-item label="密码" label-width="120px">
            <el-input v-model="temp.password"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </form-dialog>
  </div>
</template>
<script>
  import LoadButton from "../../components/LoadButton";
  import Pagination from "../../components/Pagination";
  import SmartTable from "../../components/SmartTable";
  import FormDialog from "../../components/FormDialog";
  import UploadImg from "../../components/UploadImg";
  import Dropdown from "../../components/Dropdown";
  export default{
    components: {
      Dropdown,
      UploadImg,
      FormDialog,
      SmartTable,
      Pagination,
      LoadButton
    },
    data(){
      return {
        searchParams: {
          page: 1
        },
        searchData: {},
        opt: [
          {label: '编辑', fn: this.getDetail},
          {label: '删除', fn: this.del}
        ],
        labels: [
          {prop: 'gardenName', label: '小区'},
          {prop: 'passport', label: '账号'},
          {prop: 'password', label: '密码'},
        ],
        temp: {}
      }
    },
    computed: {
      list(){
        let arr = []
        for (var i in this.$store.state.tasKeyMap) {
          arr.push({id: i, name: this.$store.state.tasKeyMap[i]})
        }
        return arr
      },
    },
    mounted(){
      this.getList()
    },
    methods: {
      search(stop){
        this.searchParams.page = 1
        this.getList(stop)
      },
      toPage(page){
        this.searchParams.page = page
        this.getList()
      },
      getList(callback){
        this.$http$({
          method: 'get',
          url: "/smartMeterServer/GardenAccount",
          data: this.searchParams,
          load: 1
        }, (data) => {
          callback ? callback() : ''
          this.searchData = data
        })
      },
      getDetail(obj){
        this.temp = JSON.parse(JSON.stringify(obj))
        this.$refs.model.show()
      },
      add(){
        this.temp = {}
        this.$refs.model.show()
      },
      del(obj){

        let data = obj
        data.status = 9
        let method = 'put',msg = '删除管理员信息成功！'
        this.$fnConfirm('小区管理员删除后将无法使用，确认删除？',() => {
          this.$http$({method: method, url: '/smartMeterServer/GardenAccount', data: data}, (data) => {
            this.getList()
            this.$success(msg)
          })
        })
      },
      save(){
        let method = 'post', url = '/smartMeterServer/GardenAccount', msg = '新增管理员成功！'
        if (this.temp.id) {
          method = 'put'
          msg = '修改管理员信息成功！'
        }
        this.$http$({method: method, url: url, data: this.temp}, (data) => {
          this.getList()
          this.$success(msg)
        })

      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/admin/GardenAccount.vue